import {
  Text,
  InlineChildren,
  Spacing,
  StackChildren,
} from '@doordash/design-language'
import styled from 'styled-components'

type StyleProps = {
  styles?: any
  size?: any
}

export const PropStack = styled(StackChildren).attrs<StyleProps>({
  size: StackChildren.Sizes.XLarge,
})`
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
`

export const PropInline = styled(InlineChildren).attrs<StyleProps>({
  size: StackChildren.Sizes.XLarge,
})`
  text-align: center;
`

export const MainTitleText = styled(Text).attrs<StyleProps>({
  styles: Text.Styles.MajorPageTitle,
})`
  text-align: center;
  padding-bottom: ${Spacing.XLarge}px;
  font-size: 36px;
`

export const TitleText = styled(Text).attrs<StyleProps>({
  styles: Text.Styles.PageTitle,
})`
  font-size: 18px;
`

export const DescriptionText = styled(Text).attrs<StyleProps>({
  styles: Text.Styles.PageDescriptionBody,
})`
  line-height: ${Spacing.Large}px;
`
